export default __webpack_public_path__ + "static/media/strategyChi2.cdb9b154.jpg";